module.exports = __webpack_public_path__ + "images/bg-cash-coupon@2x-bef1ba7079d4cd623c8b1c61a6d80c1e.png";